import { svgColor, svgUri } from '../../helpers'
import { Input } from '../Input'
import { StyleFn } from '..'

const IconUnfoldMore = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m9 15 3 3 3-3M9 9l3-3 3 3" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>',
}

export const Select: StyleFn = (theme) => {
  const { size, color } = theme
  const { root: input, _small, _valid, _invalid } = Input(theme)
  const bgSvgColor = color.type === 'light' ? color.palette.primaryblue['60'] : color.palette.white

  return {
    root: {
      ...input,
      alignItems: 'center',
      paddingRight: size.spacing[32],
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 1rem top 50%',
      backgroundImage: svgUri(svgColor(IconUnfoldMore.data, bgSvgColor)),
      backgroundSize: '1.25rem',
      '&:hover': {
        cursor: 'pointer',
      },
      '&:disabled': {
        ...input['&:disabled'],
        pointerEvents: 'auto',
      },
      '&:disabled:hover': {
        cursor: 'not-allowed',
      },
    },
    _small,
    _valid,
    _invalid,
    _hasPlaceholder: {
      color: color.getModalValues(color.text.secondary),
    },
  }
}
